import { AncillaryButton, breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { analytics } from '@eti/utils';
import { useProductCardContext } from '../../../context/ProductCardContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ancillaryButtonWrapper = css`
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    width: auto;
  }
`;
const SingleChoiceAddToCart = ({
  input
}) => {
  const {
    extraProps,
    productName
  } = useProductCardContext();
  const {
    addLabel,
    removeLabel
  } = extraProps;
  const isSelected = String((extraProps === null || extraProps === void 0 ? void 0 : extraProps.selectedValue) || input.value) === 'true';
  const handleAdd = () => input.onChange('true');
  const handleRemove = () => input.onChange('false');
  analytics.useLogMouseFlowTagEffect('add to cart');
  return /*#__PURE__*/_jsx("div", {
    className: "buttonWrapper addToCartButtonWrapper",
    children: /*#__PURE__*/_jsx(AncillaryButton, {
      addLabel: addLabel,
      className: ancillaryButtonWrapper,
      "data-testid": "ancillary-button",
      id: `${productName}_${isSelected}`,
      name: productName,
      onAdd: handleAdd,
      onRemove: handleRemove,
      removeLabel: removeLabel,
      selectedValue: isSelected,
      value: `${isSelected}`,
      variant: "secondary"
    })
  });
};
export default SingleChoiceAddToCart;
//# sourceMappingURL=SingleChoiceAddToCart.js.map